import { Metric } from './analytics-api/schema.model';

export class MetricFilterSource {
  metric: Metric;

  constructor(metric: Metric) {
    if (metric) {
      this.metric = metric;
    }
  }

  public get name(): string {
    return this.metric.name;
  }

  public get displayName(): string {
    return this.metric.displayName as string;
  }

  public get key(): string {
    return `${this.name}`;
  }

  public get format() {
    return this.metric.format;
  }
}
